import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-teaser-meta/jb-ref-teaser-meta.ts
import "@bjb/bjb-web-components/dist/components/icons/jb-calendar-icon/jb-calendar-icon";
import "@bjb/bjb-web-components/dist/components/jb-date/jb-date";
import "@bjb/bjb-web-components/dist/components/jb-time/jb-time";
import { initializeLink, jbLinkClickedEventToJbTrackingEvent, Linkable } from "@bjb/bjb-web-components/dist/mixins";
import { spreadProps } from "@open-wc/lit-helpers";
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property, queryAll } from "lit/decorators.js";
import { when } from "lit/directives/when.js";

// src/components/jb-ref-teaser-meta/jb-ref-teaser-meta.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_teaser_meta_default = css`/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.tags, .infos {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

.tags .tag a {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.infos {
  font-size: var(--theme-typo-standard-fontsize, 0.688rem);
  font-weight: var(--theme-typo-standard-fontweight, var(--theme-font-bold-weight, 700));
  letter-spacing: var(--theme-typo-uppercase-standard-letterspacing, 0.063rem);
  line-height: var(--theme-typo-standard-lineheight, 1rem);
  text-transform: uppercase;
}

.tags .tag a {
  color: rgba(var(--rgb-primary, 20, 30, 85), var(--text-opacity, var(--theme-opacity-70, 0.7)));
  font-size: 0.813rem;
  line-height: 1.25rem;
}

.sr-only {
  block-size: 1px;
  border: 0;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

.infos {
  display: flex;
  flex-wrap: wrap;
  letter-spacing: 1px;
  gap: var(--theme-spacing-s);
}
.infos div {
  display: inline-flex;
}
.infos jb-calendar-icon {
  margin-right: 10px;
}

.infos + .tags {
  margin-top: var(--theme-spacing-s, 20px);
}

.tags {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--theme-spacing-3xs);
}
@media (min-width: 600px) {
  .tags {
    gap: var(--theme-spacing-xs);
  }
}
.tags .tag {
  display: flex;
}
.tags .tag a {
  border: 1px solid rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
  color: #141e55 !important;
  font-weight: 300;
  padding: 4px 9px;
  text-decoration: none;
  transition: border 0.7s ease-in-out 0s;
}
.tags .tag a:hover {
  border: 1px solid #141e55;
  transition: border 0.7s ease-in-out 0s;
}`;

// src/components/jb-ref-teaser-meta/jb-ref-teaser-meta.ts
var JbRefTeaserMeta = class extends Linkable(LitElement) {
  constructor() {
    super(...arguments);
    this.tags = [];
  }
  updated() {
    this._tagLinks?.forEach((link) => {
      initializeLink(link);
    });
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "teaser-meta"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _renderInfos() {
    return this.infos?.map((info) => {
      switch (info.type) {
        case "date":
          return html`<div><jb-calendar-icon></jb-calendar-icon><jb-date date=${info.value}></jb-date></div>`;
        case "readingTime":
          return html`<div>
            <jb-time time=${info.value}></jb-time>
          </div>`;
        case "text":
          return html`<span>${info.value}</span>`;
        default:
          return nothing;
      }
    });
  }
  _renderTags() {
    return this.tags?.map(
      (tag) => html`<div class="tag">
          <a
            ${spreadProps({ ...tag.link })}
            @jb-link:clicked=${this._tracking}
            >${tag.text}</a
          >
        </div>`
    );
  }
  render() {
    return html`<div class="teaser-meta">
      ${when(this.infos?.length, () => html`<div class="infos">${this._renderInfos()}</div>`)}
      ${when(this.tags?.length, () => html`<div class="tags">${this._renderTags()}</div>`)}
    </div>`;
  }
};
JbRefTeaserMeta.styles = unsafeCSS(jb_ref_teaser_meta_default);
__decorateClass([
  property({ type: Array })
], JbRefTeaserMeta.prototype, "infos", 2);
__decorateClass([
  property({ type: Array })
], JbRefTeaserMeta.prototype, "tags", 2);
__decorateClass([
  queryAll("a")
], JbRefTeaserMeta.prototype, "_tagLinks", 2);
JbRefTeaserMeta = __decorateClass([
  customElement("jb-ref-teaser-meta")
], JbRefTeaserMeta);

export {
  JbRefTeaserMeta
};
